<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="flex-be">
        <div class="search_condition">
          <!-- <el-date-picker class="m-r-10" size="small" v-model="dateTime" type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" @change="changeTime">
          </el-date-picker> -->
      <div style="display: flex;">
        <el-form  label-width="80px" class="demo-ruleForm" style="display: flex;">
          <el-form-item label="公司名称" prop="" class="infoItem">
            <el-input v-model="enterpriseName" placeholder="请输入公司名称" style="width: 100%"></el-input>
          </el-form-item>
          <el-form-item label="最小金额" prop="" class="infoItem">
            <el-input v-model="minBudget" placeholder="请输入最小金额" style="width:  100%"></el-input>
          </el-form-item>
          <el-form-item label="最大金额" prop="" class="infoItem">
            <el-input v-model="maxBudget" placeholder="请输入最大金额" style="width:  100%"></el-input>
          </el-form-item>
          </el-form>
          <el-select  v-model="status" placeholder="请选择" class="search_condition_item"
            @change="getDataFn">
            <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>

          <el-button size="small" type="primary" @click="getDataFn" style="height: 40px;margin-left: 10px;"> 查询</el-button>
      </div>
          <!-- <el-select size="small" v-model="demandType" placeholder="请选择" class="search_condition_item"
            @change="getDataFn">
            <el-option v-for="item in demandTypeList" :key="item.value" :label="item.name" :value="item.value">
            </el-option>
          </el-select> -->
          
        </div>
      </div>
      <div class="content_table">
        <tableTotal v-if="configTable.tableData.length > 0" :index-show="configTable.indexShow"
          :config-data="configTable.configData" :table-data="configTable.tableData" :loading="configTable.loading"
          @handleClick="handleClick" @selectChange="handleSelectionChangeFn"
          @handleSelectionChange="handleSelectionChangeFn">
         
        </tableTotal>
        <el-empty v-if="configTable.tableData.length <= 0" description="暂无数据"></el-empty>
      </div>
      <div class="flex-be m-t-20">
        <!-- <el-button size="small" type="primary" @click="batchDeletionFn">批量删除</el-button> -->
        <el-pagination @current-change="getDataFn" @size-change="handleSizeChange"
          :current-page.sync="configTable.current" layout="total, sizes, prev, pager, next, jumper" background
          :page-sizes="[10, 15, 20]" :page-size="configTable.pageSize" :total="configTable.total"></el-pagination>
      </div>
    </el-card>
  </div>
  </template>
  
  <script>
  import tableTotal from "@/components/TableTotal/TableTotal";
  
  export default {
    name: "favoritesList",
    // import引入的组件需要注入到对象中才能使用
    components: {
      tableTotal
    },
    filters: {
      filter(value) {
        if (!value) {
          return '-'
        }
        if (!value.goodsSpec) {
          return '-'
        }
        if (value.goodsSpec[0] === '{') {
          let str = value.goodsSpec.slice(1, value.goodsSpec.length - 1)
          return str.replace(/,/g, ',').replace(/"/g, '').replace(/:/g, ' : ')
        }
      }
    },
    data() {
      // 这里存放数据
      return {
        dateTime: '',
        status:'',
        "enterpriseName":'',
          "maxBudget": '',
          "minBudget": '',
        statusList: [
          { value: '', label: '全部审核', },
          { value: 0, label: '待审核', },
          { value: 1, label: '审核通过', },
          { value: 2, label: '审核不通过', },
        ],
        demandType:'',
        demandTypeList: [
        { value: '', name: '全部', },
        {
            value: 1,
            name: '影像数据'
          },
          {
            value: 2,
            name: '数据产品'
          },
          {
            value: 3,
            name: '软件工具'
          },
          {
            value: 4,
            name: '其他产品'//'接口服务',
          }
        ],
        // 配置表格
        configTable: {
          loading: false,
          indexShow: false,
          configData: [
            // {
            //   type: 'selection'
            // },
           
            {
              value: 'demandTitle',
              label: '需求标题',
              align: 'center'
            },
            // {
            //   value: 'demandDescribe',
            //   label: '需求描述',
            //   width: 220,
            //   align: 'left',
            // },
           {
              value: 'demandType',
              label: '需求类别',
              align: 'center',
              objList: { //
                1: '影像数据',
                2: '数据产品',
                3: '软件工具',
                4: '其他产品'//'接口服务',
              }
            },{
              value: 'enterpriseName',
              label: '公司名称',
              align: 'center',
            },{
              value: 'contactName',
              label: '联系人',
              align: 'center',
            },{
              value: 'phoneNumber',
              label: '联系电话',
              align: 'center',
            },
            {
              value: 'minBudget',
              label: '最低预算',
              align: 'center',
              // type: "price"
            }, {
              value: 'maxBudget',
              label: '最高预算',
              align: 'center',
              // type: "price"
            },
            {
              value: 'updateTime',
              label: '修改时间',
              align: 'center',
              type: 'timeDate'
            },
            {
              value: 'status',
              label: '状态',
              align: 'center',
              objList: { //
                0: '待审核',
                1: '审核通过',
                2: '审核不通过',
              }
            },
            {
              value: 'publish',
              label: '发布状态',
              align: 'center',
              objList: { 
                0: '未发布',
                1: '已发布',
              }
            },
            
            {
              label: '操作', width: '220', fixed: 'right', type: 'handleList', buttonList: [
                { label: '查看', event: 'seeData', show: true, showText: true },
                { label: '编辑', event: 'editData', show: true, showText: true },
                { label: '发布', event: 'fabu', show: false, showText: true ,
                showCondition: row => {
                  return (row.status== 1 && row.publish==0 );
								}},
                { label: '取消发布', event: 'calfabu', show: false, showText: true ,
                showCondition: row => {
                  return (row.status== 1 && row.publish==1 );
								
								}},
                // {
                //   label: '删除', event: 'delete', show: true, showText: true,
                //   text: '确定删除该收藏?',
                // },
              ]
            }
          ],
          tableData: [],
          current: 1, // 当前页码
          total: 10, // 数据总条数
          pageSize: 10
        },
        tableSelect: []
      }
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {
      this.info();
    },
    // 方法集合
    methods: {
      info() {
        // 获取数据
        this.getDataFn();
      },
      changeTime() {
        this.configTable.current = 1;
        this.getDataFn();
      },
      async getDataFn() {
        let params = {
             "enterpriseName": this.enterpriseName,
              "maxBudget": this.maxBudget,
              "minBudget": this.minBudget,
              "pageNum": this.configTable.current,
              "pageSize": this.configTable.pageSize,
              "status": this.status,
              "userId": this.$store.state.user.userInfo.id,
        };
        try {
          this.configTable.loading = true;
          let res = await this.$http.post(this.$const.personalCenter.getdemandpage, params);
          if (res && res.data) {
            console.log(res);
            this.configTable.tableData = res.data.list;
            this.configTable.total = res.data.total;
            this.configTable.loading = false;
          }
        } catch (e) {
          this.configTable.loading = false;
          // console.log(e);
        }
      },
      async handleClick(event, data, text) {
        switch (event) {
          case 'seeData':
            this.$router.push({ name: "ReleaseRequirements", query: { id: data.id,edit:false}});
            break;
            case 'editData':
            this.$router.push({ name: "ReleaseRequirements", query: { id: data.id,edit:true}});
            break;
            case 'fabu':
            try {
              this.configTable.loading = true;
              let res = await this.$http.post(this.$const.personalCenter.demandpush+data.id, {});
              if (res && res.data) {
                this.configTable.loading = false;
                this.$message.success(this.$PubText.successCom);
                  this.getDataFn();
              }
            } catch (e) {
              this.configTable.loading = false;
              // console.log(e);
            }
            break;
            case 'calfabu':
            try {
              this.configTable.loading = true;
              let res = await this.$http.post(this.$const.personalCenter.demandcancel+data.id, {});
              if (res && res.data) {
                this.configTable.loading = false;
                this.$message.success(this.$PubText.successCom);
                  this.getDataFn();
              }
            } catch (e) {
              this.configTable.loading = false;
              // console.log(e);
            }
            break;
        //   case 'delete':
        //     this.$confirm(text, "提示", {
        //       confirmButtonText: "确定",
        //       cancelButtonText: "取消",
        //       type: "warning",
        //     })
        //       .then(async () => {
        //         let p = {
        //           collectId: data.id
        //         };
        //         await this.collectDeleteFn(p);
        //       });
        //     break;
        }
      },
      async collectDeleteFn(data) {
        try {
          let res = await this.$http.delete(this.$const.personalCenter.collectDelete, data);
          if (res && res.code === 200) {
            // console.log(res);
            this.$message.success(this.$PubText.successCom);
            this.getDataFn();
          }
        } catch (e) {
          // console.log(e);
        }
      },
      handleSizeChange(val) {
        this.configTable.pageSize = val;
        this.getDataFn();
      },
      // 表格多选 全选
      handleSelectionChangeFn(data) {
        this.tableSelect = data;
      },
      batchDeletionFn() {
        if (this.tableSelect.length <= 0) {
          this.$message.warning(this.$PubText.multipleTip);
          return;
        }
        const ids = this.tableSelect.map((item) => {
          return item.id
        });
        let p = {
          collectId: ids.toString()
        };
        this.collectDeleteFn(p);
      },
    },
  }
  </script>
  
  <style lang="scss" scoped>
  .search_condition_item {
    width: 140px;
    margin-left: 10px;
  }
  
  .pagination_box {
    text-align: right;
  }
  </style>
  